// Request Types - Using const assertions for TypeScript compatibility
export const RequestType = {
  TABLE_SERVICE: 'TABLE_SERVICE',
  ORDER_MODIFICATION: 'ORDER_MODIFICATION',
  ASSISTANCE: 'ASSISTANCE',
  BILL_REQUEST: 'BILL_REQUEST',
  CALL_STEWARD: 'CALL_STEWARD',
  CUSTOM_MESSAGE: 'CUSTOM_MESSAGE'
} as const;
export type RequestType = typeof RequestType[keyof typeof RequestType];

export const RequestStatus = {
  PENDING: 'PENDING',
  CLAIMED: 'CLAIMED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED'
} as const;
export type RequestStatus = typeof RequestStatus[keyof typeof RequestStatus];

export const EventType = {
  CUSTOMER_REQUEST: 'CUSTOMER_REQUEST',
  STEWARD_ACTION: 'STEWARD_ACTION',
  ORDER_STATUS_CHANGE: 'ORDER_STATUS_CHANGE',
  SYSTEM_EVENT: 'SYSTEM_EVENT'
} as const;
export type EventType = typeof EventType[keyof typeof EventType];

// Request type display names
export const REQUEST_TYPE_LABELS: Record<RequestType, string> = {
  [RequestType.TABLE_SERVICE]: 'Table Service',
  [RequestType.ORDER_MODIFICATION]: 'Order Modification',
  [RequestType.ASSISTANCE]: 'Assistance',
  [RequestType.BILL_REQUEST]: 'Bill Request',
  [RequestType.CALL_STEWARD]: 'Call Steward',
  [RequestType.CUSTOM_MESSAGE]: 'Custom Message'
};

// Request type icons
export const REQUEST_TYPE_ICONS: Record<RequestType, string> = {
  [RequestType.TABLE_SERVICE]: '🍽️',
  [RequestType.ORDER_MODIFICATION]: '✏️',
  [RequestType.ASSISTANCE]: '❓',
  [RequestType.BILL_REQUEST]: '💳',
  [RequestType.CALL_STEWARD]: '🔔',
  [RequestType.CUSTOM_MESSAGE]: '💬'
};

// Customer Request Interface
export interface CustomerRequest {
  id: number;
  requestType: RequestType;
  status: RequestStatus;
  message: string;
  tableId: number;
  tableName: string;
  orderId?: number;
  customerName?: string;
  customerPhone?: string;
  claimedBy?: string;
  claimedById?: number;
  claimedAt?: string;
  completedAt?: string;
  createdAt: string;
}

// Event Interface - NotificationEvent to avoid conflict with global Event type
export interface NotificationEvent {
  id: number;
  eventType: EventType;
  title: string;
  description: string;
  vendorId?: number;
  tableId?: number;
  tableName?: string;
  orderId?: number;
  userId?: number;
  userName?: string;
  stewardId?: number;
  stewardName?: string;
  metadata?: Record<string, any>;
  createdAt: string;
}

// Steward Performance Interface
export interface StewardPerformance {
  stewardId: number;
  stewardName: string;
  completedCount: number;
}

// Request Creation Data
export interface CreateCustomerRequestData {
  vendorId: number;
  tableId: number;
  orderId?: number;
  requestType: RequestType;
  message: string;
  customerName?: string;
  customerPhone?: string;
}

// Timeline Filter Parameters
export interface TimelineFilterParams {
  tableId?: number;
  orderId?: number;
  eventType?: EventType;
  page?: number;
  size?: number;
}

